import * as React from 'react';
import {Tab} from 'semantic-ui-react';
import {RouteComponentProps} from 'react-router';
import UsersView from "./UsersView";
import GroupsView from "./GroupsView";
import RolesView from "./RolesView";
import PrivilegesView from "./PrivilegesView";
import {translate} from 'react-i18next';
import {connect, Dispatch} from "react-redux";

import ErrorBoundary from '../../../utils/ErrorBoundary';
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import {compose} from "redux";
import {MenuDto} from "../../../services/Client";
import HATEOASClient from "../../../services/HATEOASClient";
import {selectAdminArealinks, selectClient, selectActiveIndex} from '../../../redux/selectors';
import {IReduxState} from 'src/redux/IReduxState';
import ProMTGroupsView from "./ProMTGroupsTab/ProMTGroupsView";
import AdminViewActions from '../../../redux/actions/AdminViewActions';

interface IMapStateToProps {
    adminAreaLinks?: MenuDto;
    client: HATEOASClient;
    activeIndex: number;
}

interface IMapDispatchToProps {
    changeActiveAccesTab: (
        accessTabAndFilter: {
            activeIndex: number;
            filter?: string;
        }) => void;
}

interface IOwnProps {

}

interface AccessTabProps extends
    IMapStateToProps,
    IMapDispatchToProps,
    IOwnProps,
    ITranslatedComponent,
    RouteComponentProps<any> { }

class AccessTab extends React.Component<AccessTabProps> {

    render() {
        const panes = [];

        if (this.props.adminAreaLinks) {

            if (this.props.client.GET_userList(this.props.adminAreaLinks).canExecute()) {
                panes.push({
                    menuItem: {key: 'Users', icon: 'user', content: this.props.t("USERS_TAB")},
                    render: () => <Tab.Pane key='user' ><ErrorBoundary ><UsersView {...this.props} /></ErrorBoundary></Tab.Pane>,
                });
            }
            if (this.props.client.GET_groupList(this.props.adminAreaLinks).canExecute()) {
                panes.push({
                    menuItem: {key: 'Groups', icon: 'group', content: this.props.t("GROUPS_TAB")},
                    render: () => <Tab.Pane key='group'><ErrorBoundary ><GroupsView {...this.props} /></ErrorBoundary></Tab.Pane>,
                });
            }
            if (this.props.client.GET_groupList(this.props.adminAreaLinks).canExecute()) {
                panes.push({
                    menuItem: {key: 'ProMT Groups', icon: 'group', content: this.props.t("PROMT_GROUPS_TAB")},
                    render: () => <Tab.Pane key='group'><ErrorBoundary ><ProMTGroupsView {...this.props} /></ErrorBoundary></Tab.Pane>,
                });
            }
            if (this.props.client.GET_roleList(this.props.adminAreaLinks).canExecute()) {
                panes.push({
                    menuItem: {key: 'Roles', icon: 'protect', content: this.props.t("ROLES_TAB")},
                    render: () => <Tab.Pane key='role'><ErrorBoundary ><RolesView {...this.props} /></ErrorBoundary></Tab.Pane>,
                });
            }
            if (this.props.client.GET_privilegeList(this.props.adminAreaLinks).canExecute()) {
                panes.push({
                    menuItem: {key: 'Privileges', icon: 'unhide', content: this.props.t("PRIVILEGES_TAB")},
                    render: () => <Tab.Pane key='rights'><ErrorBoundary ><PrivilegesView {...this.props} /></ErrorBoundary></Tab.Pane>,
                });
            }
        }

        return (
            <Tab
                menu={{pointing: true}}
                panes={panes}
                renderActiveOnly={true}
                activeIndex={this.props.activeIndex}
                onTabChange={(e: any, {activeIndex}: any) => this.props.changeActiveAccesTab({activeIndex})}
            />
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    adminAreaLinks: selectAdminArealinks(state),
    client: selectClient(state),
    activeIndex: selectActiveIndex(state)
});

const mapDispatchToProps = (dispacht: Dispatch<IReduxState>): IMapDispatchToProps => ({
    changeActiveAccesTab: (accessTabAndFilter) => dispacht(AdminViewActions.ChangeActiveAccesTab(accessTabAndFilter))
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("ADMIN_VIEW"),
    connect<IMapStateToProps>(mapStateToProps, mapDispatchToProps)
)(AccessTab);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/AccessTab.tsx